import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ListingDetail from "@/pages/ListingDetail";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import LegalPage from "@/pages/LegalPage";
import { initConsent } from "@/lib/consent";

function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin") || location.pathname === "/prihlaseni";
  return (
    <>
      {!isAdmin && <Navbar />}
      {children}
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => {
    initConsent();
  }, []);

  return (
    <div className="App grain">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/katalog" element={<Catalog />} />
                  <Route path="/inzerat/:id" element={<ListingDetail />} />
                  <Route path="/kontakt" element={<Contact />} />
                  <Route path="/prihlaseni" element={<Login />} />
                  <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                  <Route path="/ochrana-osobnich-udaju" element={<LegalPage docKey="privacy" />} />
                  <Route path="/cookies" element={<LegalPage docKey="cookies" />} />
                  <Route path="/obchodni-podminky" element={<LegalPage docKey="terms" />} />
                  <Route path="/reklamacni-rad" element={<LegalPage docKey="reklamace" />} />
                  <Route path="/odstoupeni-od-smlouvy" element={<LegalPage docKey="odstoupeni" />} />
                </Routes>
              </Layout>
              <CookieBanner />
            </SmoothScroll>
            <Toaster position="top-center" theme="dark" richColors />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
